import { AnimatePresence } from "framer-motion";
import { useQuickRankState } from "../../../hooks/quickrank/useQuickRankState";
import { Card } from "./Card";
import { RatedCard } from "./RatedCard";

export const Cards = () => {
  const [
    {
      configuration: {
        gameVisuals: { themeColor },
      },
      status: { isRatingRejectedCards },
      cards: {
        all: cardsToRender,
        rated: [ratedCard],
      },
    },
  ] = useQuickRankState();

  return (
    <AnimatePresence>
      {cardsToRender.map((card) => card && <Card color={themeColor} key={card.index} card={card} />)}

      {isRatingRejectedCards && ratedCard && <RatedCard key={ratedCard.attribute.id} card={ratedCard} />}
    </AnimatePresence>
  );
};
